module.exports = __webpack_public_path__ + "public/img/app_code.e3204e53.png";